// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Main Styles for MinJournal CMS
 */

 * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

:root {
    --bg-primary: #ffffff;
    --bg-secondary: #f7f7f5;
    --bg-tertiary: #f1f1ef;
    --text-primary: #37352f;
    --text-secondary: #787774;
    --text-tertiary: #9b9a97;
    --border: #e9e9e7;
    --accent: #2383e2;
    --accent-hover: #1a73d1;
    --success: #0f7b0f;
    --error: #e16259;
    --shadow: rgba(15, 15, 15, 0.1);
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
    background: var(--bg-secondary);
    color: var(--text-primary);
    line-height: 1.6;
    min-height: 100vh;
}

/* Buttons */
.btn {
    padding: 10px 16px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.btn-primary {
    background: var(--accent);
    color: white;
}

.btn-primary:hover {
    background: var(--accent-hover);
}

.btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-secondary {
    background: transparent;
    border: 1px solid var(--border);
    color: var(--text-primary);
}

.btn-secondary:hover {
    background: var(--bg-tertiary);
}

.btn-add {
    background: var(--accent);
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-add:hover {
    background: var(--accent-hover);
}

.btn-icon {
    padding: 6px 12px;
    border: 1px solid var(--border);
    background: var(--bg-primary);
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s;
}

.btn-icon:hover {
    background: var(--bg-tertiary);
}

.btn-icon.delete {
    color: var(--error);
    border-color: var(--error);
}

.btn-icon.delete:hover {
    background: #fee;
}

/* Forms */
.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-group label {
    font-size: 14px;
    font-weight: 500;
    color: var(--text-primary);
}

.form-group input,
.form-group textarea,
.form-group select {
    padding: 10px 12px;
    border: 1px solid var(--border);
    border-radius: 4px;
    font-size: 14px;
    background: var(--bg-primary);
    color: var(--text-primary);
    font-family: inherit;
    transition: border-color 0.2s;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
    outline: none;
    border-color: var(--accent);
}

.form-group textarea {
    resize: vertical;
    min-height: 80px;
}

.input-group {
    margin-bottom: 16px;
}

.input-group label {
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-primary);
    margin-bottom: 6px;
}

.input-group input,
.input-group textarea,
.input-group select {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid var(--border);
    border-radius: 4px;
    font-size: 14px;
    font-family: inherit;
    background: var(--bg-primary);
    color: var(--text-primary);
    transition: border-color 0.2s;
}

.input-group input:focus,
.input-group textarea:focus,
.input-group select:focus {
    outline: none;
    border-color: var(--accent);
}

.input-group textarea {
    resize: vertical;
    min-height: 80px;
}

/* Loading */
.loading {
    display: none;
    text-align: center;
    padding: 32px;
}

.loading.show {
    display: block;
}

.spinner {
    border: 3px solid var(--border);
    border-top: 3px solid var(--accent);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin: 0 auto 16px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Toast */
.toast {
    position: fixed;
    bottom: 24px;
    right: 24px;
    background: var(--text-primary);
    color: white;
    padding: 12px 20px;
    border-radius: 6px;
    box-shadow: 0 4px 12px var(--shadow);
    display: none;
    z-index: 2000;
    font-size: 14px;
}

.toast.show {
    display: block;
    animation: slideIn 0.3s;
}

.toast.error {
    background: var(--error);
}

@keyframes slideIn {
    from {
        transform: translateX(400px);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Error Message */
.error-message {
    background: #fee;
    color: var(--error);
    padding: 12px;
    border-radius: 4px;
    font-size: 14px;
    display: none;
    margin-bottom: 16px;
}

.error-message.show {
    display: block;
}

/* Modal */
.modal {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    overflow-y: auto;
    padding: 24px;
}

.modal.show {
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

.modal-content {
    background: var(--bg-primary);
    border-radius: 8px;
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    margin-top: 24px;
    box-shadow: 0 4px 16px var(--shadow);
}

.modal-header {
    padding: 20px 24px;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    background: var(--bg-primary);
    z-index: 10;
}

.modal-header h2 {
    font-size: 18px;
    font-weight: 600;
}

.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: var(--text-secondary);
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s;
}

.close-btn:hover {
    background: var(--bg-tertiary);
}

.modal-body {
    padding: 24px;
}

/* Rows */
.row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
}

/* Checkbox Labels */
.checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: var(--text-primary);
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 4px;
    transition: background-color 0.2s;
    user-select: none;
}

.checkbox-label:hover {
    background: var(--bg-tertiary);
}

.checkbox-label input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: var(--accent);
}

/* Utility Classes */
.text-center {
    text-align: center;
}

.mb-16 {
    margin-bottom: 16px;
}

.mb-24 {
    margin-bottom: 24px;
}

.mt-24 {
    margin-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;;EAEE;;CAED;IACG,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,sGAAsG;IACtG,+BAA+B;IAC/B,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;;;IAGI,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;;;IAGI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,6BAA6B;IAC7B,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;;IAGI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,mCAAmC;IACnC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,UAAU;AACV;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,MAAM;IACN,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/**\n * Main Styles for MinJournal CMS\n */\n\n * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n:root {\n    --bg-primary: #ffffff;\n    --bg-secondary: #f7f7f5;\n    --bg-tertiary: #f1f1ef;\n    --text-primary: #37352f;\n    --text-secondary: #787774;\n    --text-tertiary: #9b9a97;\n    --border: #e9e9e7;\n    --accent: #2383e2;\n    --accent-hover: #1a73d1;\n    --success: #0f7b0f;\n    --error: #e16259;\n    --shadow: rgba(15, 15, 15, 0.1);\n}\n\nbody {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;\n    background: var(--bg-secondary);\n    color: var(--text-primary);\n    line-height: 1.6;\n    min-height: 100vh;\n}\n\n/* Buttons */\n.btn {\n    padding: 10px 16px;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.btn-primary {\n    background: var(--accent);\n    color: white;\n}\n\n.btn-primary:hover {\n    background: var(--accent-hover);\n}\n\n.btn-primary:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.btn-secondary {\n    background: transparent;\n    border: 1px solid var(--border);\n    color: var(--text-primary);\n}\n\n.btn-secondary:hover {\n    background: var(--bg-tertiary);\n}\n\n.btn-add {\n    background: var(--accent);\n    color: white;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-add:hover {\n    background: var(--accent-hover);\n}\n\n.btn-icon {\n    padding: 6px 12px;\n    border: 1px solid var(--border);\n    background: var(--bg-primary);\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 13px;\n    transition: all 0.2s;\n}\n\n.btn-icon:hover {\n    background: var(--bg-tertiary);\n}\n\n.btn-icon.delete {\n    color: var(--error);\n    border-color: var(--error);\n}\n\n.btn-icon.delete:hover {\n    background: #fee;\n}\n\n/* Forms */\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.form-group label {\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-primary);\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n    padding: 10px 12px;\n    border: 1px solid var(--border);\n    border-radius: 4px;\n    font-size: 14px;\n    background: var(--bg-primary);\n    color: var(--text-primary);\n    font-family: inherit;\n    transition: border-color 0.2s;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n    outline: none;\n    border-color: var(--accent);\n}\n\n.form-group textarea {\n    resize: vertical;\n    min-height: 80px;\n}\n\n.input-group {\n    margin-bottom: 16px;\n}\n\n.input-group label {\n    display: block;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-primary);\n    margin-bottom: 6px;\n}\n\n.input-group input,\n.input-group textarea,\n.input-group select {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid var(--border);\n    border-radius: 4px;\n    font-size: 14px;\n    font-family: inherit;\n    background: var(--bg-primary);\n    color: var(--text-primary);\n    transition: border-color 0.2s;\n}\n\n.input-group input:focus,\n.input-group textarea:focus,\n.input-group select:focus {\n    outline: none;\n    border-color: var(--accent);\n}\n\n.input-group textarea {\n    resize: vertical;\n    min-height: 80px;\n}\n\n/* Loading */\n.loading {\n    display: none;\n    text-align: center;\n    padding: 32px;\n}\n\n.loading.show {\n    display: block;\n}\n\n.spinner {\n    border: 3px solid var(--border);\n    border-top: 3px solid var(--accent);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n    margin: 0 auto 16px;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* Toast */\n.toast {\n    position: fixed;\n    bottom: 24px;\n    right: 24px;\n    background: var(--text-primary);\n    color: white;\n    padding: 12px 20px;\n    border-radius: 6px;\n    box-shadow: 0 4px 12px var(--shadow);\n    display: none;\n    z-index: 2000;\n    font-size: 14px;\n}\n\n.toast.show {\n    display: block;\n    animation: slideIn 0.3s;\n}\n\n.toast.error {\n    background: var(--error);\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(400px);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n/* Error Message */\n.error-message {\n    background: #fee;\n    color: var(--error);\n    padding: 12px;\n    border-radius: 4px;\n    font-size: 14px;\n    display: none;\n    margin-bottom: 16px;\n}\n\n.error-message.show {\n    display: block;\n}\n\n/* Modal */\n.modal {\n    display: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    z-index: 1000;\n    overflow-y: auto;\n    padding: 24px;\n}\n\n.modal.show {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n.modal-content {\n    background: var(--bg-primary);\n    border-radius: 8px;\n    width: 100%;\n    max-width: 800px;\n    max-height: 90vh;\n    overflow-y: auto;\n    margin-top: 24px;\n    box-shadow: 0 4px 16px var(--shadow);\n}\n\n.modal-header {\n    padding: 20px 24px;\n    border-bottom: 1px solid var(--border);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: sticky;\n    top: 0;\n    background: var(--bg-primary);\n    z-index: 10;\n}\n\n.modal-header h2 {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.close-btn {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: var(--text-secondary);\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: all 0.2s;\n}\n\n.close-btn:hover {\n    background: var(--bg-tertiary);\n}\n\n.modal-body {\n    padding: 24px;\n}\n\n/* Rows */\n.row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 12px;\n}\n\n/* Checkbox Labels */\n.checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: var(--text-primary);\n    cursor: pointer;\n    padding: 8px 12px;\n    border-radius: 4px;\n    transition: background-color 0.2s;\n    user-select: none;\n}\n\n.checkbox-label:hover {\n    background: var(--bg-tertiary);\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    accent-color: var(--accent);\n}\n\n/* Utility Classes */\n.text-center {\n    text-align: center;\n}\n\n.mb-16 {\n    margin-bottom: 16px;\n}\n\n.mb-24 {\n    margin-bottom: 24px;\n}\n\n.mt-24 {\n    margin-top: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
